import { selectProductsInCart, selectTradeInOrderAttributes, setTradeInErrorMessage, useDispatch, useSelector, } from "@jti/store";
export const useCartTradeInError = () => {
    const dispatch = useDispatch();
    const { tradeInErrorMessage } = useSelector((store) => store.cart);
    const selectedTradeInOrderAttributes = useSelector(selectTradeInOrderAttributes);
    const { traded_in_model } = selectedTradeInOrderAttributes || {};
    const productsInCart = useSelector(selectProductsInCart);
    const isTradeInItemInCart = productsInCart.some((item) => !!item.tradeIn);
    const setError = (errorMessage) => {
        dispatch(setTradeInErrorMessage(errorMessage));
    };
    return {
        isTradeInItemInCart,
        isTradeInItemSelected: !!traded_in_model,
        errorMessage: tradeInErrorMessage,
        setError,
    };
};
//# sourceMappingURL=useCartTradeInError.js.map